"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var _default = {
  defaultTip: "默认项",
  setDefault: "设为默认项",
  redirect: "账号与权限管理"
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProjectSelect/locale/zh_CN.js
// module id = 2141
// module chunks = 6 7 17 18